import http from '../http.js';

// 注册
function register(params) {
	return http.post('/user/register',
		params
	);
}
// 登录
function login(params) {
	return http.post('/user/login',
		params
	);
}
// 忘记密码
function resetpwd(params) {
	return http.post('/user/resetpwd',
		params
	);
}
// 首页轮播图
function banner(params) {
	return http.get('/index/banner', {
		params
	});
}
// 网站底部信息
function other(params) {
	return http.get('/index/other', {
		params
	});
}
// 公告列表
function notice(params) {
	return http.get('/index/notice', {
		params
	});
}
// 公告详情
function noticeinfo(params) {
	return http.get('/index/noticeinfo', {
		params
	});
}
// 入库指南
function rkzn(params) {
	return http.get('/index/rkzn', {
		params
	});
}
// 投标指南
function zbzn(params) {
	return http.get('/index/zbzn', {
		params
	});
}
// 公告投标文件上传
function noticesubmit(params) {
	return http.post('/index/noticesubmit',
		params
	);
}
// 公告列表
function mynotice(params) {
	return http.get('/index/mynotice', {
		params
	});
}
// 获取个人信息
function userindex(params) {
	return http.get('/user/index', {
		params
	});
}
// 修改个人资料
function userupdate(params) {
	return http.post('/user/update', params);
}
// 获取验证码
function send(params) {
	return http.post('/sms/send', params);
}


export default {
	register,
	login,
	resetpwd,
	banner,
	other,
	notice,
	noticeinfo,
	rkzn,
	zbzn,
	noticesubmit,
	mynotice,
	userindex,
	userupdate,
	send
}